import { render, staticRenderFns } from "./cAdminTagsAlt.vue?vue&type=template&id=1016d439&scoped=true"
import script from "./cAdminTagsAlt.vue?vue&type=script&lang=js"
export * from "./cAdminTagsAlt.vue?vue&type=script&lang=js"
import style0 from "./cAdminTagsAlt.vue?vue&type=style&index=0&id=1016d439&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1016d439",
  null
  
)

export default component.exports